/** useState for a settings object that survives reloads (localStorage); new fields get defaults. */
import { useEffect, useState } from 'react';

export function usePersistentState<T extends object>(
  key: string,
  initial: T,
): [T, (v: T | ((prev: T) => T)) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw ? { ...initial, ...(JSON.parse(raw) as T) } : initial;
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Private mode / quota: settings simply won't persist.
    }
  }, [key, value]);
  return [value, setValue];
}
